<template>

        <div class="col-xl-6 col-12 d-flex flex-wrap justify-content-center justify-content-xl-start align-content-start align-items-start mt-md-4 mt-xl-0">
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-0" >
                Nombre Remitente
            </div>
            <div class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <input tabindex="1" ref="senderName" type="text" maxlength="30" autocomplete='off' spellcheck='false' autocorrect='off' class="w-100 inputText t-xxl-4 t-16 t-sm-11 t-xl-8" placeholder="Nombre" v-model="formFields.step4.senderName" @paste="pasteFilterLetter($event)" @copy="disableCopy" @keydown="onlyLetters($event)">
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                WhatsApp Remitente
            </div>
            <div class="col-xxl-8 col-10 d-flex justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <input tabindex="2" ref="senderWhatsapp" maxlength="10" autocomplete='off' pattern="\d*" spellcheck='false' autocorrect='off' class="w-100 inputText t-xxl-4 t-16 t-sm-11 t-xl-8" placeholder="Numero telefónico 10 digitos"  v-model="formFields.step4.senderWhatsapp" :type="(mobile == true) ? 'tel' : 'text'" @paste="pasteFilterNumber($event)" @copy="disableCopy" @keydown="onlyNumbers($event)">
            </div>
            <div class="col-xxl-8 col-10 text-start titleOption t-18 t-sm-14 t-xl-9 t-xxl-6 mb-1 mb-xl-3 mt-4 mt-xl-5">
                Forma de Pago
            </div>
            <div class="col-xxl-8 col-10 d-flex flex-wrap justify-content-start align-content-start align-items-start ps-xl-4 ps-2">
                <div class="w-100 d-flex flex-nowrap justify-content-start align-content-start align-items-stretch mt-4">
                    <div class="col-auto">
                        <div class="commonPageCheckbox">
                            <input name="sendMoment"  value="online" v-model="formFields.step4.payForm" type="radio">
                            <label @keyup.enter="setValue('step4', 'payForm', 'online')" tabindex="3" for="test" class="me-1 inputLabel" @click="setValue('step4', 'payForm', 'online')">
                                <span class="pe-none"><img :src="simbol"></span>
                            </label>
                        </div>
                    </div>
                    <div role="button" class="flex-fill d-flex flex-wrap justify-content-start align-content-start align-items-start" @click="setValue('step4', 'payForm', 'online')">  
                        <div class="titleOption2 t-18 t-sm-15 t-xl-9 t-xxl-6 w-100 text-start ps-3">Pagar en Línea</div>
                        <div class="subtitleOption2 t-16 t-sm-13 t-xl-8 t-xxl-5 ps-xxl-5 ps-4 text-start">Se te pedirán los datos de tu tarjeta para pagar en línea</div>
                    </div>
                </div>
                <div class="w-100 d-flex flex-nowrap justify-content-start align-content-start align-items-stretch mt-4 mt-xl-5">
                    <div class="col-auto">
                        <div class="commonPageCheckbox">
                            <input name="sendMoment" value="store" v-model="formFields.step4.payForm" type="radio">
                            <label @keyup.enter="setValue('step4', 'payForm', 'store')" tabindex="4" for="test" class="me-1 inputLabel" @click="setValue('step4', 'payForm', 'store')">
                            <span class="pe-none"><img :src="simbol"></span></label>
                        </div>
                    </div>
                    <div role="button" class="flex-fill d-flex flex-wrap justify-content-start align-content-start align-items-start" @click="setValue('step4', 'payForm', 'store')">
                        <div class="titleOption2 t-18 t-sm-15 t-xl-9 t-xxl-6 w-100 text-start ps-3">Pagar en Sucursal</div>
                        <div class="subtitleOption2 t-16 t-sm-13 t-xl-8 t-xxl-5 ps-xxl-5 ps-4 text-start">Se enviará tu pedido de Gift Card a una sucursal, deberás pagar en efectivo o con terminal antes de terminar el día.</div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-8 col-10 text-start ts-2 mt-5 d-flex justify-content-end">
                <button tabindex="5" class="generalButton t-xl-12 t-xxl-8 t-30 t-sm-24" @click="validateNextness()">Continuar</button>
            </div>
        </div>

</template>

<script>
import whatsAppView from '@/components/whatsAppView.vue'

export default {
    name: 'step4',
    emits:['setData', 'progress', 'showModal', 'setLoading'],
    components:{
        whatsAppView
    },
    props: {
        lang:{
            default:"es",
            type: String
        },
        con:{
            default:{},
            type: Object
        },
        formFields: {},
        cities:{
            default:[],
            type: Array
        }
    },
    methods:{
        setValue(step, field, value){
            let form = this.formFields[step];
            form[field] = value;
            this.$emit('setData', form, step);
        },
        step(step){
            this.$emit('progress', step);
        },
        setErr(name){
            this.$refs[name].classList.add('err')
        },
        removeErr(name){
            this.$refs[name].classList.remove('err')
        },
        validateNextness(){
            let senderName = this.validateField('text', this.formFields.step4.senderName, 100, 3);
            let senderWhatsapp = this.validateField('number', this.formFields.step4.senderWhatsapp, 10, 10);

            if(senderName){
                this.removeErr('senderName')
            }else{
                this.setErr('senderName')
            }
            if(senderWhatsapp){
                this.removeErr('senderWhatsapp')
            }else{
                this.setErr('senderWhatsapp')
            }
            if(senderName && senderWhatsapp){
                this.step(4)
            }
        },
    },
    mounted(){
        this.mobile = this.isMobile();
        let node = document.getElementById('masterComponent');
        node.scrollTo({
            top: 0, // Altura total del documento
            behavior: 'smooth' // Animación suave
        });
    },
    data() {
        return {
            simbol:require('@/assets/images/a27.svg'),
            mobile:false
        }
    }
}
</script>

<style scoped lang="css">
.titleOption{
    color: var(--primary);
    font-weight: 600;
}
.subtitleOption{
    color: var(--sexagenary);
}
.inputText{
    border: 2px solid var(--quartenary);
    border-radius: 12px;
    padding: 12px;
    outline: none;
    color: var(--primary);
}

textarea{
    resize: none;
}
.linkChange{
    color: var(--septagenary);
    cursor: pointer;
    font-weight: 700;
}
.linkChange:hover{
    color: var(--primary);
}

.commonPageCheckbox input:not(:checked) + label:hover{
    border:5px solid var(--secondary);
}
.commonPageCheckbox input:not(:checked) + label>span{
    display: none;
}
.commonPageCheckbox input{
    display: none;
}
.commonPageCheckbox label{
    cursor:pointer;
    width: 30px;
    height: 30px;
    border:3px solid var(--quinary);
    border-radius: 6px;
    overflow: visible;
}
.commonPageCheckbox img{
    width: 100%;
    height: 100%;
    margin-left: 15%;
    transform: scaleX(2.2) scaleY(2.2) translateY(-10%);
}
.commonPageCheckbox span{
    background-color: transparent;
}
.titleOption2{
    color: var(--primary);
    font-weight: 600;
}
.subtitleOption2{
    color: var(--sexagenary);
}
@media (min-width: 768px) {
    .commonPageCheckbox label{
        border:5px solid var(--quinary);
        width: 40px;
        height: 40px;
    }
}
</style>
